//#region src/bite_log_square_event.ts
var BiteLogSquareEvent = /* @__PURE__ */ function(BiteLogSquareEvent) {
	BiteLogSquareEvent[BiteLogSquareEvent["None"] = 0] = "None";
	BiteLogSquareEvent[BiteLogSquareEvent["AuthorizationSuccess"] = 1] = "AuthorizationSuccess";
	BiteLogSquareEvent[BiteLogSquareEvent["AuthorizationError"] = 2] = "AuthorizationError";
	BiteLogSquareEvent[BiteLogSquareEvent["ReaderSettingsSuccess"] = 3] = "ReaderSettingsSuccess";
	BiteLogSquareEvent[BiteLogSquareEvent["ReaderSettingsError"] = 4] = "ReaderSettingsError";
	BiteLogSquareEvent[BiteLogSquareEvent["CheckoutErrorDeprecated"] = 5] = "CheckoutErrorDeprecated";
	BiteLogSquareEvent[BiteLogSquareEvent["ReaderDisconnected"] = 6] = "ReaderDisconnected";
	BiteLogSquareEvent[BiteLogSquareEvent["CheckoutCancelled"] = 7] = "CheckoutCancelled";
	BiteLogSquareEvent[BiteLogSquareEvent["CheckoutErrNotAuthorized"] = 8] = "CheckoutErrNotAuthorized";
	BiteLogSquareEvent[BiteLogSquareEvent["CheckoutErrUsageError"] = 9] = "CheckoutErrUsageError";
	BiteLogSquareEvent[BiteLogSquareEvent["CheckoutTimeout"] = 10] = "CheckoutTimeout";
	BiteLogSquareEvent[BiteLogSquareEvent["CheckoutNoNetwork"] = 13] = "CheckoutNoNetwork";
	BiteLogSquareEvent[BiteLogSquareEvent["CheckoutLocationServicesDisabled"] = 14] = "CheckoutLocationServicesDisabled";
	BiteLogSquareEvent[BiteLogSquareEvent["PairingSuccess"] = 11] = "PairingSuccess";
	BiteLogSquareEvent[BiteLogSquareEvent["PairingError"] = 12] = "PairingError";
	return BiteLogSquareEvent;
}(BiteLogSquareEvent || {});
//#endregion
export { BiteLogSquareEvent };

//# sourceMappingURL=bite_log_square_event.js.map